import React, { useState } from 'react'
import './styles.scss'
import info from './../../images/i-ico.svg'
import infoBlue from './../../images/i-ico-blue.svg'
import ModalMessage from '../modal-message/ModalMessage';

const Heading = (props) => {
    let [ activeModal, setActiveModal ] = useState(false);

    return (
        <>
        <div id={props.id ? props.id : ""} className={"heading " + ( props.big ? 'big' : '') + ( props.medium ? 'medium' : '') + ( props.small ? ' small' : '') + (props.otherMargins ? ' other-margins' : '') + (props.smallBigger ? ' small-bigger' : '') + (props.smallMargin ? ' small-margin' : '' + (props.withoutMargin ? ' without-margin' : '') + (props.verySmallBottomMargin ? ' very-small-margin-bottom' : '') + (props.class ? ' ' + props.class : ''))}>
            <h2>
                { props.title }
            </h2>
            { props.tip && !props.tipBlueIcon && 
                <img src={ info } alt="informacja" onClick={ () => setActiveModal( true )} />
            }
            { props.tip && props.tipBlueIcon && 
                <img src={ infoBlue } className="big-ico" alt="informacja" onClick={ () => setActiveModal( true )} />
            }
        </div>
        { activeModal &&
            <ModalMessage closeModal={ () => setActiveModal(false) } 
                          button={ props.button } 
                          buttonClass="blue" 
                          buttonTitle={ props.buttonTitle }
                          buttonArrow={ true } 
                          tipHeader={ props.tipHeader }
                          tipText={ props.tipText } />
        }
        </>
    )
}

export default Heading;